/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotPluginOverviewResponse,
  BotPluginOverviewGetOverviewParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botPluginOverviewGetOverviewResponse200 = {
  data: ApiEnvelopeBotPluginOverviewResponse
  status: 200
}

export type botPluginOverviewGetOverviewResponse401 = {
  data: ApiEnvelopeBotPluginOverviewResponse
  status: 401
}

export type botPluginOverviewGetOverviewResponseSuccess = (botPluginOverviewGetOverviewResponse200) & {
  headers: Headers;
};
export type botPluginOverviewGetOverviewResponseError = (botPluginOverviewGetOverviewResponse401) & {
  headers: Headers;
};

export type botPluginOverviewGetOverviewResponse = (botPluginOverviewGetOverviewResponseSuccess | botPluginOverviewGetOverviewResponseError)

export const getBotPluginOverviewGetOverviewUrl = (params?: BotPluginOverviewGetOverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botengine/plugins/overview?${stringifiedParams}` : `/api/botengine/plugins/overview`
}

export const useBotPluginOverviewGetOverviewHook = (): (params?: BotPluginOverviewGetOverviewParams, options?: RequestInit) => Promise<botPluginOverviewGetOverviewResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: BotPluginOverviewGetOverviewParams, options?: RequestInit) => {

        return customFetcher(getBotPluginOverviewGetOverviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


